(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-varios-productos-deslizbles"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vs-collection-item')) {
  customElements.define('vs-collection-item', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      if (!this.querySelector('.vs-track')) { requestAnimationFrame(()=>{if(this.isConnected)this.connectedCallback();}); return; }
      this.bound = true;
      this.abort = new AbortController();
      const on = (el, type, fn, opts={}) => el?.addEventListener(type, fn, {...opts, signal:this.abort.signal});
      this.track = this.querySelector('.vs-track');
      this.blockClickUntil = 0;
      on(this,'click',e=>this.click(e));
      on(this,'change',e=>{if(e.target.matches('[data-value-id]')) this.changeVariant(e.target);});
      on(this,'submit',e=>this.add(e));
      on(this.track,'scroll',()=>this.counter(),{passive:true});
      on(this.track,'dragstart',e=>e.preventDefault());
      on(this.track,'keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.slide(e.key==='ArrowLeft'?-1:1);}});
      let start=null, dragging=false, mouseScroll=0;
      on(this.track,'pointerdown',e=>{start={x:e.clientX,y:e.clientY};dragging=false;mouseScroll=this.track.scrollLeft;});
      on(this.track,'pointermove',e=>{
        if(!start)return;
        const dx=e.clientX-start.x,dy=e.clientY-start.y;
        if(Math.hypot(dx,dy)>8){dragging=true;this.blockClickUntil=Date.now()+600;}
        if(e.pointerType==='mouse' && e.buttons===1 && dragging){this.track.style.scrollSnapType='none';this.track.scrollLeft=mouseScroll-dx;}
      });
      const release=()=>{start=null;this.track.style.scrollSnapType='';if(dragging)this.blockClickUntil=Date.now()+600;};
      on(window,'pointerup',release);on(window,'pointercancel',release);
      let distance=0, zoomImage=null;
      const dist=t=>Math.hypot(t[0].clientX-t[1].clientX,t[0].clientY-t[1].clientY);
      on(this.track,'touchstart',e=>{
        if(e.touches.length===2 && this.dataset.pinch==='true'){
          distance=dist(e.touches);zoomImage=e.target.closest('.vs-slide')?.querySelector('img');
          this.blockClickUntil=Date.now()+900;if(zoomImage)e.preventDefault();
        }
      },{passive:false});
      on(this.track,'touchmove',e=>{
        if(zoomImage && e.touches.length===2){e.preventDefault();this.blockClickUntil=Date.now()+900;zoomImage.style.setProperty('--zoom',Math.min(Number(this.dataset.zoom),Math.max(1,dist(e.touches)/Math.max(1,distance))));}
      },{passive:false});
      const endZoom=()=>{if(zoomImage){zoomImage.style.removeProperty('--zoom');zoomImage=null;this.blockClickUntil=Date.now()+700;}};
      on(this.track,'touchend',endZoom);on(this.track,'touchcancel',endZoom);
      this.resize=new ResizeObserver(()=>this.counter());this.resize.observe(this.track);
      requestAnimationFrame(()=>{if(this.isConnected)this.sync();});
    }
    disconnectedCallback(){this.abort?.abort();this.request?.abort();this.resize?.disconnect();this.bound=false;}
    counter(){
      const total=this.track.children.length,index=Math.round(this.track.scrollLeft/Math.max(1,this.track.clientWidth));
      const counter=this.querySelector('[data-counter]');if(counter)counter.textContent=`${index+1} / ${total}`;
      const prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]');if(prev)prev.disabled=index<=0;if(next)next.disabled=index>=total-1;
    }
    slide(delta){this.track.scrollBy({left:delta*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
    click(e){
      if(e.target.closest('[data-prev]')){this.slide(-1);return;}
      if(e.target.closest('[data-next]')){this.slide(1);return;}
      if(e.target.closest('.vs-gallery') && Date.now()<this.blockClickUntil){e.preventDefault();e.stopPropagation();return;}
      if(e.target.closest('.vs-reviews') && !e.target.closest('a')){location.href=this.dataset.productUrl+'#judgeme_product_reviews';return;}
      if(e.target.closest('a,button,input,select,textarea,label,fieldset,[data-no-link],.shopify-payment-button'))return;
      if(this.dataset.cardLink!=='true'||!e.target.closest('.vs-card')||window.getSelection()?.toString()||window.Shopify?.designMode)return;
      location.href=this.dataset.link;
    }
    sync(){
      const state=this.querySelector('.vs-state');if(!state)return;
      this.dataset.link=state.dataset.url;
      this.querySelectorAll('.vs-slide,.vs-title a,.vs-details').forEach(a=>a.href=this.dataset.link);
      const image=Array.from(this.track.children).find(el=>el.dataset.image===state.dataset.featured);
      if(image)this.track.scrollLeft=image.offsetLeft-this.track.firstElementChild.offsetLeft;
      this.counter();
    }
    async changeVariant(input){
      if(input.dataset.productUrl && new URL(input.dataset.productUrl,location.origin).pathname!==new URL(this.dataset.productUrl,location.origin).pathname){location.href=input.dataset.productUrl;return;}
      this.request?.abort();this.request=new AbortController();
      const state=this.querySelector('.vs-state'), focusValue=input.dataset.valueId;
      const url=new URL(this.dataset.productUrl,location.origin);
      url.searchParams.set('section_id',this.dataset.section);
      url.searchParams.set('option_values',Array.from(state.querySelectorAll('[data-value-id]:checked'),x=>x.dataset.valueId).join(','));
      state.setAttribute('aria-busy','true');
      try{
        const response=await fetch(url,{signal:this.request.signal});if(!response.ok)throw Error('No se pudo cargar la variante.');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const replacement=doc.getElementById(this.id)?.querySelector('.vs-state');
        if(!replacement)throw Error('No se pudo cargar la variante.');
        const updatedOffer=doc.getElementById(this.id)?.querySelector('[data-sale-slot]');
        if(updatedOffer)this.querySelector('[data-sale-slot]')?.replaceWith(updatedOffer);
        state.replaceWith(replacement);this.sync();
        replacement.querySelector(`[data-value-id="${focusValue}"]`)?.focus({preventScroll:true});
        window.Shopify?.PaymentButton?.init();
      }catch(error){if(error.name==='AbortError')return;state.removeAttribute('aria-busy');state.querySelector('.vs-message').textContent='No se pudo actualizar. Vuelve a elegir una opción o abre «Ver todos los detalles».';state.querySelectorAll('button[type="submit"],input[name="id"]').forEach(el=>el.disabled=true);state.querySelector('.vs-fast')?.setAttribute('hidden','');}
    }
    async add(e){
      if(!e.target.matches('.vs-form'))return;
      // El enlace de más opciones usa el POST nativo y lleva a checkout con esta variante.
      if(e.submitter?.name==='return_to'||this.dataset.cartMode==='page')return;
      e.preventDefault();
      const form=e.target,button=form.querySelector('[name="add"]'),message=form.querySelector('.vs-message');
      if(button.disabled)return;
      button.disabled=true;message.textContent='Añadiendo…';
      const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      const data=new FormData(form);const root=window.Shopify?.routes?.root||'/';
      if(cart?.getSectionsToRender){data.append('sections',cart.getSectionsToRender().map(s=>s.id).join(','));data.append('sections_url',location.pathname);cart.setActiveElement?.(button);}
      let added=false;
      try{
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        const result=await response.json();if(!response.ok||result.status)throw Error(result.description||'No se pudo añadir el producto.');
        added=true;
        if(cart?.renderContents && result.sections && Object.values(result.sections).every(Boolean)){cart.classList.remove('is-empty');cart.renderContents(result);message.textContent='Producto añadido al carrito.';}
        else location.href=root+'cart';
      }catch(error){if(added){location.href=root+'cart';return;}message.textContent=error.message||'No se pudo añadir. Comprueba el carrito antes de volver a intentarlo.';}
      finally{button.disabled=false;}
    }
  });
}

if(!customElements.get('vs-product-collection')){
 customElements.define('vs-product-collection',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   if(!this.querySelector('.vs-product-rail')){requestAnimationFrame(()=>{if(this.isConnected)this.connectedCallback();});return;}
   this.controller=new AbortController();
   const on=(el,type,fn,options={})=>el.addEventListener(type,fn,{...options,signal:this.controller.signal});
   this.rail=this.querySelector('.vs-product-rail');
   if(!this.rail)return;
   this.items=Array.from(this.rail.querySelectorAll('vs-collection-item'));
   this.active=0;this.suppressUntil=0;
   on(this,'click',e=>{
    if(Date.now()<this.suppressUntil){e.preventDefault();e.stopPropagation();return;}
    if(e.target.closest('[data-product-prev]'))this.go(-1);
    if(e.target.closest('[data-product-next]'))this.go(1);
   },{capture:true});
   let start=null;
   on(this.rail,'pointerdown',e=>{start={x:e.clientX,y:e.clientY};});
   on(this.rail,'pointermove',e=>{if(start&&Math.hypot(e.clientX-start.x,e.clientY-start.y)>10)this.suppressUntil=Date.now()+600;},{passive:true});
   on(window,'pointerup',()=>{start=null;});on(window,'pointercancel',()=>{start=null;});
   on(this.rail,'scroll',()=>this.update(),{passive:true});
   on(this.rail,'keydown',e=>{if(e.target!==this.rail)return;if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.go(e.key==='ArrowLeft'?-1:1);}});
   this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.rail);this.update();
  }
  update(){
   if(!this.items.length)return;
   const r=this.rail.getBoundingClientRect(),anchor=r.left;
   let closest=Infinity;
   this.items.forEach((item,index)=>{const b=item.getBoundingClientRect(),d=Math.abs(b.left-anchor);if(d<closest){closest=d;this.active=index;}});
   if(this.rail.scrollLeft+this.rail.clientWidth>=this.rail.scrollWidth-2)this.active=this.items.length-1;
   const count=this.querySelector('[data-product-count]');if(count)count.textContent=`${this.active+1} / ${this.items.length}`;
   const prev=this.querySelector('[data-product-prev]'),next=this.querySelector('[data-product-next]');
   if(prev)prev.disabled=this.active===0;if(next)next.disabled=this.active===this.items.length-1;
  }
  go(delta){
   const item=this.items[Math.max(0,Math.min(this.items.length-1,this.active+delta))];if(!item)return;
   const r=this.rail.getBoundingClientRect(),b=item.getBoundingClientRect();
   this.rail.scrollBy({left:b.left-r.left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  disconnectedCallback(){this.controller?.abort();this.resize?.disconnect();this.controller=null;}
 });
}


  } catch(e) { console.error(e); }
})();
})();
